<template>
  <div id="guide" class="mb-5">
    <ReportHeader
      :reportTypeId="reportTypeId"
      :title="title"
      :subtitle="subtitle"
    />

    <div class="row">
      <div class="col pb-5">
        <p class="guideAlign">
          The data points included below are hypothetical and are provided here
          only to give guidance regarding how to read this report.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-large-3 col-medium-6 pb-3 text-small-center guideAlign">
        <img
          src="\images\evp-guide-coincident-relationship.png"
          class="img-fluid"
        />
        <h5 class="pb-1" style="color: rgb(24, 57, 97)">
          Current Indicator Phase
        </h5>
        <p>
          The Current Indicator Phase section tells you which phase of the
          business cycle the indicator is in. It will also tell you whether the
          indicator leads, lags, or moves in real time with the company.
        </p>
      </div>
      <div class="col-large-3 col-medium-6 pb-3 text-small-center guideAlign">
        <img src="\images\evp-guide-2-month-lag-time.png" class="img-fluid" />
        <h5 class="pb-1" style="color: rgb(24, 57, 97)">2-Month Lag Time</h5>
        <p>This indicator lags the company by two months.</p>
      </div>
      <div class="col-large-3 col-medium-6 pb-3 text-small-center guideAlign">
        <img src="\images\evp-guide-5-month-lead-time.png" class="img-fluid" />
        <h5 class="pb-1" style="color: rgb(24, 57, 97)">5-Month Lead time</h5>
        <p>This indicator leads the company by five months.</p>
      </div>
      <div class="col-large-3 col-medium-6 pb-3 text-small-center guideAlign">
        <img
          src="\images\evp-guide-coincident-relationship.png"
          class="img-fluid"
        />
        <h5 class="pb-1" style="color: rgb(24, 57, 97)">
          Coincident Relationship
        </h5>
        <p>
          This indicator moves in real time with the company (no lead or lag
          time).
        </p>
      </div>
      <div class="col-large-3 col-medium-6 pb-3 text-small-center guideAlign">
        <img src="\images\evp-guide-headline 1.png" class="img-fluid" />
        <h5 class="pb-1" style="color: rgb(24, 57, 97)">Headline</h5>
        <p>
          Simple! The headline tells you what your Economist wants you to know
          about this indicator, such as what it means for the company.
        </p>
      </div>
      <div class="col-large-3 col-medium-6 pb-3 text-small-center guideAlign">
        <img
          src="\images\evp-guide-indicator-phase-signals 1.png"
          class="img-fluid"
        />
        <h5 class="pb-1" style="color: rgb(24, 57, 97)">
          Indicator Phase Signals
        </h5>
        <!-- <p>The phase signals give a suggested phase adjusted for the lead/lag time of the indicator to your company, based on the actual or expected status of the indicator.</p> -->
        <p>
          When lead/lag time is taken into account, the indicator's trajectory
          suggests a course of future business cycle phases for the company,
          shown here.
        </p>
        <p>
          <i>
            Example: ITR expects Phase B in a six-month leading indicator
            through December 2021 before a March 2022 transition to Phase C.
            This would be shown as Phase B through June 2022 and Phase C in
            September 2022, given the six-month lead time.
          </i>
        </p>
        <p>
          When an indicator signals a certain phase for the company at a given
          time, it does not mean that the company will be in that phase at that
          time.
        </p>
        <p>
          For example, the company may enter recession even if the trajectory of
          US Industrial Production suggests otherwise.
        </p>
      </div>
      <div class="col-large-3 col-medium-6 pb-3 text-small-center guideAlign">
        <img
          src="\images\evp-guide-turning-point-analysis 1.png"
          class="img-fluid"
        />
        <h5 class="pb-1" style="color: rgb(24, 57, 97)">
          Turning Point Analysis
        </h5>
        <p>
          This tells you when the indicator is reaching a cyclical high or low
          and what this suggests for the timing of the company's upcoming
          cyclical high or low, based on the leading, lagging, or coincident
          relationship.
        </p>
      </div>
      <div
        class="col-large-3 col-medium-6 pb-3 text-small-center guideAlign"
        v-if="aatk"
      >
        <img src="\images\market-landscape-guide-image.png" class="img-fluid" />
        <h5 class="pb-1" style="color: rgb(24, 57, 97)">
          Economic Landscape Overview
        </h5>
        <p>
          Indicators selected to represent the company's end-use markets are
          shown in comparison to the company data and forecast. This chart will
          allow you to assess the current and expected position of various
          end-use markets. The user can decide to hide or show indicators by
          clicking on the legend entry for each.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import ReportHeader from '~/components/report/ReportHeader.vue';
  export default {
    name: 'TimingModelGuideComponent',
    components: {
      ReportHeader,
    },
    props: {
      productType: String,
      productTypeShorthand: String,
      aatk: false,
      reportTypeId: {
        type: [String, Number],
        // required: true,
      },
    },
    computed: {
      title() {
        return `${this.productTypeShorthand} Guide`;
      },
      subtitle() {
        return ``;
      },
    },
  };
</script>
